import { TablePagination } from '@mui/material';
import React from 'react';

type Props = {
  pagina?: number;
  linhasPorPagina?: number;
  totalLinhas?: number;
  mudarPagina?: (novaPagina: number) => void;
};

const Paginacao: React.FC<Props> = (props) => {
  const { pagina, linhasPorPagina, totalLinhas, mudarPagina } = props;

  if (
    pagina === undefined ||
    linhasPorPagina === undefined ||
    totalLinhas === undefined ||
    mudarPagina === undefined
  ) {
    return null;
  }

  // if (hide) {
  //   return null;
  // }

  return (
    <TablePagination
      labelRowsPerPage=""
      component="div"
      count={totalLinhas}
      rowsPerPageOptions={[linhasPorPagina]}
      rowsPerPage={linhasPorPagina}
      page={pagina}
      onPageChange={(event, number) => mudarPagina(number)}
    />
  );
};

export default Paginacao;
